import React from "react";
import "./Mission.css";

const Mission = () => {
  const cards = [
    {
      title: "Bridge Educational Gaps",
      description:
        "Offering <span class='highlight'>Residential School Entrance Exam Training</span> to help talented students secure quality education and shape their academic journey.",
      icon: "🎓", // Education icon
    },
    {
      title: "Enhance Communication Skills",
      description:
        "Conducting <span class='highlight'>Free English Spoken Classes for government school children</span>, enabling them to gain confidence and unlock future opportunities.",
      icon: "🗣️", // Speaking icon
    },
    {
      title: "Ignite Scientific Curiosity",
      description:
        "Showcasing the <span class='highlight'>Indian Space Show</span> to inspire young learners by celebrating India's space achievements and honoring our scientists.",
      icon: "🚀", // Rocket for space/science
    },
    {
      title: "Promote Digital Safety",
      description:
        "Spreading <span class='highlight'>Cyber Security Awareness</span> to educate students about online threats, ensuring a safer digital future.",
      icon: "💻", // Laptop for digital safety
    },
  ];

  return (
    <div className="mission-container">
      <div className="mission-title-wrapper">
        <h2 className="mission-title">Our Mission</h2>
        <p className="mission-subtitle">Our Commitment to Excellence</p>
      </div>
      <div className="mission-grid">
        {cards.map((card, index) => (
          <div key={index} className="mission-card">
            <div className="mission-icon">{card.icon}</div>
            <h3 className="mission-card-title">{card.title}</h3>
            <p
              className="mission-card-description"
              dangerouslySetInnerHTML={{ __html: card.description }}
            ></p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Mission;
